import { render, staticRenderFns } from "./BDR2026OneCdictionary.vue?vue&type=template&id=62f1cc65&"
import script from "./BDR2026OneCdictionary.vue?vue&type=script&lang=js&"
export * from "./BDR2026OneCdictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports